<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>证件管理配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <!-- <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">用工场景</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item>
                  <el-input
                    v-model="ruleForm.name"
                    placeholder="请输入标题"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态">
                  <el-select
                    v-model="ruleForm.status"
                    placeholder="请选择状态"
                    style="margin-right: auto;"
                  >
                    <el-option label="上架" value="0"></el-option>
                    <el-option label="下架" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card> -->
      </div>
      <div class="pageTab">
        <el-button
          type="primary"
          class="btn"
          style="margin-bottom: 16px"
          @click="add()"
          >添加</el-button
        >
        <el-table ref="scrollTable" :data="tableData" style="width: 100%">
          <el-table-column label="ID" prop="id" align="center">
          </el-table-column>
          <el-table-column label="证件名称" prop="title" align="center">
          </el-table-column>
          <el-table-column label="排序" align="center" prop="sort">
          </el-table-column>
          <el-table-column label="lvKey" align="center" prop="lvKey">
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
                <div class="operateBtn" @click="selectItem(scope.row)">
                  查看
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="证件id" prop="num">
          <el-input
            v-model="ruleForm1.num"
            :disabled="editId"
            placeholder="请输入证件id"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件名称" prop="name">
          <el-input
            v-model="ruleForm1.name"
            placeholder="请输入证件名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="证件级别KEY" prop="key">
          <el-input
            v-model="ruleForm1.key"
            placeholder="请输入证件级别KEY"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="ruleForm1.sort"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
        status: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      editId: true,
      ruleForm1: {
        sort: "",
        num: "",
        key: "",
        name: "",
      },
      rules: {
        sort: [{ required: true, message: "必填项", trigger: "blur" }],
        num: [{ required: true, message: "必填项", trigger: "blur" }],
        name: [{ required: true, message: "必填项", trigger: "blur" }],
        key: [{ required: true, message: "必填项", trigger: "blur" }],
      },
      selectData: {},
      newList: [],
      dataID: "",
      editIndex: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    selectItem(val) {
      this.$router.push({
        path: "/grade",
        query: {
          lvKey: val.lvKey,
        },
      });
    },
    processArray(originalArr, options = {}) {
      let result = [...originalArr];

      // 修改某个索引的值
      if (options.update) {
        const { index, value } = options.update;
        if (index >= 0 && index < result.length) {
          result[index] = value;
        }
      }

      // 删除某个索引的值
      if (options.remove !== undefined) {
        const index = options.remove;
        result = result.filter((_, i) => i !== index);
      }

      // 在某个位置插入新元素
      if (options.add) {
        const { index, items } = options.add;
        result = [
          ...result.slice(0, index),
          ...(Array.isArray(items) ? items : [items]),
          ...result.slice(index),
        ];
      }

      return result;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let obj = {
            title: this.ruleForm1.name,
            lvKey: this.ruleForm1.key,
            id: this.ruleForm1.num,
            sort: this.ruleForm1.sort,
          };
          let arr = this.newList;
          let obj1 = {};
          if (this.editId == false) {
            for (var i = 0; i < arr.length; i++) {
              if (obj.id == arr[i].id) {
                this.$message({
                  message: "id重复，请重新输入id",
                  type: "warning",
                });
                return;
              }
              if (obj.id == 0) {
                this.$message({
                  message: "id不可为0",
                  type: "warning",
                });
                return;
              }
            }
            obj1 = { add: { index: 0, items: [obj] } };
          } else {
            obj1 = { update: { index: this.editIndex, value: obj } };
          }
          let newArr = this.processArray(arr, obj1);
          let param = {
            propName: "pricePremiumType_certs",
            propValue: JSON.stringify(newArr),
          };
          this.$axios
            .post(`/admapi/sys/conf/update/${this.dataID}`, param)
            .then(({ data }) => {
              this.$message({
                message: this.editId == false ? "添加成功" : "编辑成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally(() => {
              this.dialogFormVisible = false;
              this.selectData = {};
              this.ruleForm1.num = "";
              this.ruleForm1.key = "";
              this.ruleForm1.sort = "";
              this.ruleForm1.name = "";
              this.editId = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    add() {
      this.title = "新增证书";
      this.newList = this.tableData;
      this.editId = false;
      this.dialogFormVisible = true;
    },
    handleEdit(val) {
      this.title = "编辑证书";
      this.newList = this.tableData;
      let obj = {};
      for (var i = 0; i < this.newList.length; i++) {
        if (val.id == this.newList[i].id) {
          obj = this.newList[i];
          this.editIndex = i;
        }
      }
      this.ruleForm1.sort = obj.sort;
      this.ruleForm1.num = obj.id;
      this.ruleForm1.name = obj.title;
      this.ruleForm1.key = obj.lvKey;
      this.editId = true;
      this.dialogFormVisible = true;
    },
    resetForm() {
      this.ruleForm.name = "";
      this.ruleForm.status = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: 1,
        pageSize: 99999,
        queryParams: [
          {
            name: "prop_name",
            type: "input",
            value: "pricePremiumType_certs",
          },
        ],
      };
      this.$axios
        .post(`/admapi/sys/conf/list`, param)
        .then(({ data }) => {
          this.tableData = JSON.parse(data.items[0].propValue);
          this.dataID = data.items[0].id;
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let arr = this.tableData;
          let index = "";
          for (var i = 0; i < arr.length; i++) {
            if (val.id == arr[i].id) {
              index = i;
            }
          }
          let newArr = this.processArray(arr, { remove: index });
          let param = {
            propName: "pricePremiumType_certs",
            propValue: JSON.stringify(newArr),
          };

          this.$axios
            .post(`/admapi/sys/conf/update/${this.dataID}`, param)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped></style>
